<!-- TODO: Add translation here -->
<div
  class="px-5 lg:px-0 font-base pb-3"
  [style.color]="textColor | contentBuilderColor"
>
  <div
    *ngIf="deliveryAmount"
    class="flex justify-between py-3 border-neutral-300 border-b"
  >
    <div class="font-normal text-sm leading-snug">
      {{ 'basket.delivery-costs' | translate }}
    </div>
    <div class="flex flex-row justify-center items-center">
      <div
        class="icon icon-bike pl-4"
        [style.color]="secondaryTextColor | contentBuilderColor"
      ></div>
      <div class="text-sm w-20 leading-5 text-right">
        <app-price-atom
          [bold]="false"
          [amount]="deliveryAmount"
          [format]="true"
        ></app-price-atom>
      </div>
    </div>
  </div>
  <div
    *ngIf="tips"
    class="flex justify-between py-3 border-neutral-300 border-b"
  >
    <div class="font-normal text-sm leading-snug">
      {{ 'basket.additonnal-informations.tip' | translate }}
    </div>
    <div class="flex flex-row justify-center items-center">
      <div
        class="icon icon-satisfied pl-4"
        [style.color]="secondaryTextColor | contentBuilderColor"
      ></div>
      <div class="text-sm w-20 leading-5 text-right">
        <app-price-atom
          [bold]="false"
          [amount]="tips"
          [format]="true"
        ></app-price-atom>
      </div>
    </div>
  </div>
  <ng-container *ngIf="!isBasketExist">
    <div
      *ngFor="let coupon of coupons"
      class="flex justify-between py-3 border-neutral-300 border-b"
      [class.opacity-50]="coupon.removeInProgress"
    >
      <div class="font-normal text-sm leading-snug lg:text-base">
        <div>
          <ng-container *ngIf="coupon.name">
            {{ coupon.name }}
          </ng-container>
          <ng-container *ngIf="!coupon.name">
            {{ 'basket.discount-voucher' | translate }} «{{ coupon.code }}»
          </ng-container>
        </div>
        <div
          *ngIf="coupon.type === 'ERROR'"
          class="text-xs text-error-800"
        >
          <ng-container *ngIf="coupon.error">
            {{ 'voucher-modal.voucher-not-available' | translate }}
          </ng-container>
          <ng-container *ngIf="!coupon.error">
            {{ 'basket.invalid-voucher' | translate }}
          </ng-container>
        </div>
        <div>
          <a
            (click)="onRemoveCoupon(coupon)"
            class="text-primary-600 cursor-pointer"
          >
            {{ 'basket.delete' | translate }}
          </a>
        </div>
      </div>
      <div class="flex flex-row justify-end items-center">
        <div
          class="icon icon-coupon-3 pl-4"
          [style.color]="secondaryTextColor | contentBuilderColor"
          *ngIf="coupon.type !== 'ERROR'"
        ></div>
        <div
          class="icon icon-warning-circle text-error-800 pl-4"
          *ngIf="coupon.type === 'ERROR'"
        ></div>
        <div
          class="text-sm leading-5 w-20 text-right"
          *ngIf="coupon.type !== 'ERROR'"
        >
          –
          <app-price-atom
            [bold]="false"
            [amount]="coupon.amount_off"
            [format]="true"
          ></app-price-atom>
        </div>
      </div>
    </div>
  </ng-container>
  <div
    *ngIf="usePointsAmount > 0"
    class="flex justify-between py-3 border-neutral-300 border-b"
  >
    <div class="font-normal text-sm leading-snug">
      <div>Crédit fidelité</div>
      <div>
        <a
          (click)="removeUsePoints.emit()"
          class="text-primary-800"
        >
          Retirer
        </a>
      </div>
    </div>
    <span class="text-sm leading-5"
      >-<app-price-atom
        [bold]="false"
        [amount]="usePointsAmount"
        [format]="true"
      ></app-price-atom
    ></span>
  </div>
  <div
    class="flex justify-between py-3"
    [style.color]="headingColor | contentBuilderColor"
  >
    <span class="font-accent font-bold text-md leading-6">Total</span>
    <span class="font-accent font-bold text-base leading-6"
      ><app-price-atom
        [amount]="totalAmount"
        [format]="true"
      ></app-price-atom
    ></span>
  </div>
</div>
